/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { conformToMask } from 'react-text-mask';
import { get, isEmpty } from 'lodash';
import { PuffLoader } from 'react-spinners';
import PropTypes from 'prop-types';
import Header from '../../components/Header';
import Transition from '../../components/Transition';
import Button from '../../components/Button';
import FormRow from '../../components/Form/FormRow';
import FormColumn from '../../components/Form/FormColumn';
import Input from '../../components/Form/Input';
import { parseUrlParams, addLusaHeaderParam } from '../../utils/parseUrlParams';
import { formatCurrency } from '../../utils/formatCurrency';
import { numberUnmask } from '../../utils/unmasks';
import {
  offerCheckInAction,
  newNextAction,
} from '../../actions/navigation';
import Validator from '../../components/Validator';
import schema from './schema';
import Modal from '../../components/Modal';
import imgError from '../../assets/images/error.svg';
import successImage from '../../assets/images/preapproved.svg';
import './style.scss';
import { ricWorkflowName } from '../../utils/appConstants';

const ErrorHandle = ({ msg }) => (
  <div className="error-wrapper">
    <h2 className="text-center">{msg}</h2>
  </div>
);

const OfferConfirmation = (props) => {
  const match = useParams();
  const [isReady, setIsReady] = useState(false);
  const [response, setResponse] = useState({});
  const [applicationKey, setApplicationKey] = useState(null);
  const [offerName, setOfferName] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const [isTCPAModalVisible, setIsTCPAModalVisible] = useState(false);
  const [isDisclosureModalVisible, setIsDisclosureModalVisible] = useState(false);
  const [isElectronicModalVisible, seIisElectronicModalVisible] = useState(false);
  const [isPatriotModalVisible, seIsPatriotModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [snackBar, setSnackBar] = useState({
    show: false,
    message: '',
    type: '',
  });

  const params = parseUrlParams(window.location.search);
  const { validator: { values, errors, setValues }, checkinData, navigate } = props;
  const workflowType = get(match, 'workflowType') ? (get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType')) : 'dtm-luwa';
  const dpOnlyApp = workflowType === 'dtm-luwa-dponly' || workflowType === ricWorkflowName || get(response, `offers.${selectedIndex}.downPaymentRequired`);
  const ricWorkFlow = workflowType === ricWorkflowName;
  const bankOrRetailer = ricWorkFlow ? 'Retailer' : 'Bank';
  const LenderOrRetailer = ricWorkFlow ? 'Retailer' : 'Lender';

  const goToUrl = (url) => {
    let routeUrl = url;
    if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
      routeUrl = addLusaHeaderParam(routeUrl);
    }
    props.navigate(routeUrl);
  };

  useEffect(() => {
    if (params.key) {
      setApplicationKey(params.key);
    } else {
      setSnackBar({
        show: true,
        message: 'Application Key required',
        type: 'error',
      });
      return;
    }

    if (params.offerName) {
      setOfferName(params.offerName);
    } else {
      setSnackBar({
        show: true,
        message: 'Offer name required',
        type: 'error',
      });
      return;
    }

    setIsReady(false);
    setResponse({});
    setErrorMessage(null);

    if (isEmpty(checkinData)) {
      props.offerCheckInAction({
        workflowType,
        key: params.key,
        data: {
          offerName: params.offerName,
        },
        success: (res) => {
          if (get(res, 'data.data')) {
            if (get(res, 'data.url')) {
              goToUrl(get(res, 'data.url'));
            }

            if (get(res, 'data.data.phoneNumber') && !get(res, 'data.data.phoneTypeMismatch')) {
              setValues({ phoneNumber: conformToMask(get(res, 'data.data.phoneNumber'), ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]).conformedValue });
            }
            setResponse(get(res, 'data.data'));
            setSelectedIndex(get(res, 'data.data.offers', []).findIndex((offer) => offer.selected));
            setIsReady(true);
          } else {
            setErrorMessage(`Workflow not found with key ${params.key}`);
            setIsReady(true);
            setSnackBar({
              show: true,
              message: `Workflow not found with key ${params.key}`,
              type: 'error',
            });
          }
        },
        fail: (error) => {
          let failedError = 'An unexpected error occurred, please try again';
          if (get(error, 'response.data.failure.errors.0.message')) {
            failedError = get(error, 'response.data.failure.errors.0.message');
          }
          setIsReady(true);
          setResponse({});
          setErrorMessage(failedError);
          setSnackBar({
            show: true,
            message: failedError,
            type: 'error',
          });
        },
      });
    }
  }, [params.key]);

  const handleInputChange = (event) => {
    const { validator: { onChangeHandler } } = props;
    onChangeHandler(event.target.name, event.target.value);
  };

  const handleFinalizeSale = (e) => {
    e.preventDefault();
    const { validator: { validate, setErrors } } = props;
    const phoneTypeMismatch = get(response, 'phoneTypeMismatch');
    const requestConsent = get(response, 'requestConsent');

    if (applicationKey && validate(schema).isValid) {
      setIsLoading(true);

      const payload = {
        mobile: (phoneTypeMismatch || requestConsent) ? numberUnmask(values.phoneNumber) : null,
      };

      props.newNextAction({
        data: payload,
        workflowType,
        entityType: 'application',
        key: applicationKey,
        success: (res) => {
          setIsLoading(false);
          if (get(res, 'data.url')) {
            goToUrl(get(res, 'data.url'));
          } else {
            setSnackBar({
              show: true,
              message: 'An unexpected error occurred, please try again',
              type: 'error',
            });
          }
        },
        fail: (error) => {
          setIsLoading(false);
          if (get(error, 'status') === 400 && get(error, 'response.data.failure.errors.0.subject') === 'phoneNumber') {
            setErrors({
              phoneNumber: get(error, 'response.data.failure.errors.0.message'),
            });
          }

          let failedError = 'An unexpected error occurred, please try again';
          if (get(error, 'response.data.failure.errors.0.message')) {
            failedError = get(error, 'response.data.failure.errors.0.message');
          }
          setErrorMessage(failedError);
          setSnackBar({
            show: true,
            message: failedError,
            type: 'error',
          });
        },
      });
    }
  };

  const toggleDisclousureModal = () => {
    setIsDisclosureModalVisible(!isDisclosureModalVisible);
  };

  const toggleElectronicModal = () => {
    seIisElectronicModalVisible(!isElectronicModalVisible);
  };

  const toggleTCPAModal = () => {
    setIsTCPAModalVisible(!isTCPAModalVisible);
  };

  const togglePatriotModal = () => {
    seIsPatriotModalVisible(!isPatriotModalVisible);
  };

  const snackBarClose = () => {
    setSnackBar({
      show: false,
      message: '',
      type: '',
    });
  };

  return (
    <Transition className="transition-item wrapper loan-options">
      <Header navigate={navigate} />

      {snackBar.show
        ? (
          <Modal>
            <div className="card-content error-modal security-error">
              <img src={snackBar.type === 'error' ? imgError : successImage} alt="" />
              <p>{snackBar.message}</p>
              <div onClick={snackBarClose} className={`btn ${snackBar.type === 'error' ? 'btn-red' : 'btn-success'}`}>OK</div>
            </div>
          </Modal>
        )
        : null}

      {!applicationKey
        ? <ErrorHandle msg="Application Key required" />
        : null}

      {!offerName
        ? <ErrorHandle msg="Offer Name required" />
        : null}

      {!isEmpty(response) && isReady ? (
        <div className="selected-offer-wrapper" role="document">
          <h5 className="offer-page-title">You selected the following offer:</h5>
          <div className="offer-details">
            {!!Number(get(response, `offers.${selectedIndex}.zipTerm`)) && (
            <div className="no-interest-wrapper">
              <h2 className="text-primary text-center">
                { Number(get(response, `offers.${selectedIndex}.originationPercentage`)) ? 'NO INTEREST' : '0% APR' }
              </h2>
              <h5 className="text-center">
                if paid within
                {' '}
                {get(response, `offers.${selectedIndex}.zipTerm`)}
                {' '}
                months*
              </h5>
            </div>
            )}
            <FormRow>
              <FormColumn className="col-sm-6 boldText">
                Est. Monthly
                {' '}
                <br />
                {' '}
                Payment
              </FormColumn>
              <FormColumn className="text-right text-primary col-sm-6 font-30 boldText">
                $
                {formatCurrency(get(response, `offers.${selectedIndex}.paymentAmount`), 2) || '-'}
              </FormColumn>
            </FormRow>

            {dpOnlyApp && (
              <FormRow>
                <FormColumn className="col-sm-6">Amount of Sale</FormColumn>
                <FormColumn className="text-right col-sm-6 boldText">
                  $
                  {formatCurrency(get(response, `offers.${selectedIndex}.approvalAmount`), 2) || '-'}
                </FormColumn>
              </FormRow>
            )}

            <FormRow>
              <FormColumn className="col-sm-6">Amount Financed</FormColumn>
              <FormColumn className="text-right col-sm-6 boldText">
                $
                {formatCurrency(get(response, `offers.${selectedIndex}.${dpOnlyApp ? 'amountTaken' : 'approvalAmount'}`), 2) || '-'}
              </FormColumn>
            </FormRow>

            <FormRow>
              <FormColumn className="col-sm-6">{workflowType === ricWorkflowName ? 'Term' : 'Loan Term'}</FormColumn>
              <FormColumn className="text-right col-sm-6 boldText">
                {get(response, `offers.${selectedIndex}.term`)}
                {' '}
                Months
              </FormColumn>
            </FormRow>

            {!dpOnlyApp && !!Number(get(response, `offers.${selectedIndex}.originationPercentage`)) && (
            <FormRow>
              <FormColumn className="col-sm-6">Origination Fee</FormColumn>
              <FormColumn className="text-right col-sm-6 boldText">
                {Number(get(response, `offers.${selectedIndex}.originationPercentage`))
                  ? formatCurrency(Number(get(response, `offers.${selectedIndex}.originationPercentage`)) * 100, 2)
                  : '0'}
                %
              </FormColumn>
            </FormRow>
            )}

            <FormRow>
              <FormColumn className="col-sm-6">Interest Rate</FormColumn>
              <FormColumn className="text-right col-sm-6 boldText">
                {formatCurrency(get(response, `offers.${selectedIndex}.rate`), 2) || '-'}
                %
              </FormColumn>
            </FormRow>

            <FormRow>
              <FormColumn className="col-sm-6">Est. APR</FormColumn>
              <FormColumn className="text-right col-sm-6 boldText">
                {formatCurrency(get(response, `offers.${selectedIndex}.apr`), 4) || '-'}
                %
              </FormColumn>
            </FormRow>

            {get(response, `offers.${selectedIndex}.downPaymentRequired`) ? (
              <FormRow className="down-payment-row">
                <FormColumn className="col-sm-6">
                  <p>
                    Down Payment
                    <sup>1</sup>
                  </p>
                </FormColumn>
                <FormColumn className="text-right col-sm-6 boldText">
                  <b>
                    $
                    {formatCurrency(get(response, `offers.${selectedIndex}.downPaymentRequired`), 2)}
                  </b>
                </FormColumn>
              </FormRow>
            ) : null}

            {get(response, 'phoneTypeMismatch') && (
            <div className="phone-type-mismatch-wrapper">
              <div className="phone-error-msg">
                Unfortunately, XXX-XXX-
                {get(response, 'phoneLast4Digits')}
                {' '}
                is not a mobile number. Please provide a valid mobile number to continue.
              </div>
              <div className="">
                <label className="inputLabel has-value required">
                  <Input
                    type="text"
                    label="Mobile Phone"
                    name="phoneNumber"
                    placeHolder="(___) ___-____"
                    isMasked={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                    value={values.phoneNumber}
                    onChange={handleInputChange}
                    hasError={!!errors.phoneNumber}
                    errorMessage={errors.phoneNumber}
                    isRequired
                  />
                </label>
              </div>
            </div>
            )}

            {get(response, 'requestConsent') && get(response, 'phoneNumber') && !get(response, 'phoneTypeMismatch') && (
            <div className="mt-2">
              <p>Please confirm your mobile number.</p>
              <div className="mt-2">
                <label className="inputLabel">
                  <Input
                    type="text"
                    label="Mobile Phone"
                    name="phoneNumber"
                    placeHolder="(___) ___-____"
                    isMasked={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                    value={values.phoneNumber}
                    onChange={handleInputChange}
                    hasError={!!errors.phoneNumber}
                    errorMessage={errors.phoneNumber}
                    isRequired
                  />
                </label>
              </div>
            </div>
            )}

            {get(response, 'requestConsent')
                  && (
                  <div className="mb-2" style={{ fontSize: '10px' }}>
                    I consent to receive calls and texts to any phone number I provide for any purpose, including marketing, under these
                    {' '}
                    <span className="text-primary text-link" onClick={toggleTCPAModal}>terms</span>
                    .
                  </div>
                  )}

            <Button type="button" id="SubmitLoanSelection" onClick={handleFinalizeSale} isLoading={isLoading} className="w-100 text-13 btn btn-primary mb-2">
              TEXT MY PHONE TO PROCEED
            </Button>

            {get(response, 'requestConsent')
                  && (
                  <div className="mb-2" style={{ fontSize: '10px' }}>
                    By clicking &#34;TEXT MY PHONE TO PROCEED&#34;, I hereby agree and consent to the
                    {' '}
                    <span className="text-primary text-link" onClick={toggleDisclousureModal}>terms, conditions, acknowledgements and disclosures</span>
                    {' '}
                    and to the
                    {' '}
                    <span className="text-primary text-link" onClick={toggleElectronicModal}>Electronic Consent</span>
                    .
                  </div>
                  )}

            {get(response, 'requestConsent')
                  && (
                  <div className="mb-2">
                    <div style={{ fontSize: '10px' }}>
                      Important information about procedures for opening a new account;
                      <span> </span>
                      <span id="patriot-popover" className="text-primary text-link" onClick={togglePatriotModal}>USA PATRIOT Act Notice</span>
                      {isPatriotModalVisible
                        ? (
                          <Modal>
                            <div className="card-content error-modal security-error">
                              <p>USA PATRIOT Act Notice</p>
                              <div className="offer-page modal-content-wrapper">
                                To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account.
                                <br />
                                What this means for you: When you open an account, we will ask for your name, address, date of birth, and other information that will allow us to identify you. We may also ask to see your driver&apos;s license or other identifying documents.
                                <br />
                              </div>
                              <div onClick={togglePatriotModal} className="btn btn-primary">OK</div>
                            </div>
                          </Modal>
                        )
                        : null}
                    </div>
                  </div>
                  )}
            {get(response, `offers.${selectedIndex}.downPaymentRequired`) ? (
              <div className="mb-2">
                <div style={{ fontSize: '10px' }}>
                  <sup style={{ verticalAlign: 'super', fontSize: 'smaller' }}>1</sup>
                  &nbsp;In connection with your intended purchase, the merchant requires a down payment in the amount shown above. Your down payment to the merchant for your purchase is a condition to the fulfilment of your loan offer.
                </div>
              </div>
            ) : null}
            <p className="text-center ml-auto mr-auto mt-2 mb-0">Need Help? Call (800) 994-6177</p>

            {isTCPAModalVisible ? (
              <Modal>
                <div className="card-content error-modal security-error">
                  <p>TCPA Consent</p>
                  <div className="offer-page modal-content-wrapper">
                    By providing the telephone number above and clicking &#34;TEXT MY PHONE TO PROCEED&#34;, you confirm you are the owner of the phone number(s), or that the owner authorized you to provide the phone number(s), or that you are the regular user of this phone number(s). You are providing express written consent via your electronic signature to receive any type of communication for any purpose, including telemarketing communications, from our
                    {' '}
                    <a href="https://lendingusa.com/lending-partners/" style={{ textDecoration: 'underline' }} target="_blank" rel="noopener noreferrer">lending partners</a>
                    , LendingUSA, their agents, representatives, affiliates, assignees or anyone calling on their behalf, at the telephone number(s) provided for any lawful purpose, even if that number is on a federal or state do-not-call list. The scope of this consent includes, but is not limited to, receiving live operator calls, calls and texts via an automatic telephone dialing system (auto-dialer), prerecorded and artificial voice messages, text/SMS messages or other means. These telephone calls and text messages may incur message, data and access fees from your telephone provider. Consent is not a condition to obtain
                    {' '}
                    {ricWorkFlow ? 'financing' : 'a loan'}
                    .
                    <br />
                    <br />
                    that you can request a paper copy of these terms or may withdraw your consent at any time by:
                    <br />
                    <ul className="modal-list-item">
                      <li>mailing your written request to LendingUSA c/o Compliance Department at 15303 Ventura Blvd., Suite 850, Sherman Oaks, CA 91403;</li>
                      <li>
                        by e-mailing
                        {' '}
                        <a href="mailto:customercare@lendingusa.com">customercare@lendingusa.com</a>
                        ; or
                      </li>
                      <li>by calling LendingUSA at (800) 994-6177.</li>
                    </ul>
                    You may also reply &#34;STOP&#34; to opt out of receiving autodialed text messages only.
                  </div>
                  <div onClick={toggleTCPAModal} className="btn btn-primary">OK</div>
                </div>
              </Modal>
            ) : null}

            {isDisclosureModalVisible ? (
              <Modal>
                <div className="card-content error-modal security-error">
                  <p>Terms, conditions, acknowledgements and disclosures</p>
                  <div className="offer-page modal-content-wrapper">
                    {ricWorkFlow ? (
                      <>
                        By clicking “I agree” you authorize LendingUSA, LLC, (“LendingUSA”),
                        {' '}
                        {get(checkinData, 'data.data.businessName') ? `${get(checkinData, 'data.data.businessName')}, ` : null}
                        {get(checkinData, 'data.data.dba') ? ` dba ${get(checkinData, 'data.data.dba')} ` : null}
                        {' '}
                        (“Retailer”)
                      </>
                    ) : (
                      <>
                        By clicking &#34;TEXT MY PHONE TO PROCEED&#34; or other links assenting to our terms, you acknowledge that you agreed that any data that you provided to our third-party partner may be transferred to LendingUSA, LLC (&#34;LendingUSA&#34;) and these
                        {' '}
                        <a href="https://lendingusa.com/lending-partners/" style={{ textDecoration: 'underline' }} target="_blank" rel="noopener noreferrer">lenders</a>
                        {' '}
                        (each a &#34;Lender&#34;) for the processing of your loan application (&#34;Application&#34;).  You also authorize LendingUSA to use such data in accordance with its
                        {' '}
                        <a href="http://www.lendingusa.com/privacy-policy">privacy policy</a>
                        . You further authorize LendingUSA, Lender,
                      </>
                    )}
                    {' '}
                    and their affiliated third parties (&#34;Third Parties&#34;) to forward your
                    {' '}
                    {ricWorkFlow ? (
                      <>
                        application for financing
                        (&#34;Application&#34;)
                      </>
                    ) : <>Application, </>}
                    including your non-public personal information, to third parties to verify the information contained in your Application, including, but not limited to the following: (1) contacting your employer(s) to verify employment and income; (2) contacting your Merchant Provider (if applicable) to verify any of the following information: (i) the type of procedure(s), service(s) and/or product(s) to be provided; (ii) the date of service; (iii) cost of the goods and/or services to be provided. You acknowledge that you have reviewed and agree to our Privacy Policy which can be found at
                    {' '}
                    <a href="http://www.lendingusa.com/privacy-policy">http://www.lendingusa.com/privacy-policy</a>
                    {' '}
                    and you have reviewed and agree to our Terms of Use which can be found at
                    {' '}
                    <a href="http://www.lendingusa.com/terms-of-use">http://www.lendingusa.com/terms-of-use</a>
                    .
                    <br />
                    <br />
                    You understand that APRs will vary depending upon credit ratings and/or the payment terms that are approved. Credit approvals are valid for a limited time only. You understand that checking your rate and reviewing loan offers on LendingUSA&#39;s Text-to-Apply mobile platform, merchant portal, or any other LendingUSA affiliated online platform results in a soft credit inquiry which does not affect your credit score. However, if you receive a preapproval (“Offer“) from LendingUSA, and you select an Offer provided to you and proceed with
                    {' '}
                    {ricWorkFlow ? 'completing a retail installment sale' : 'acquiring a loan from the Lender'}
                    , then LendingUSA and/or
                    {' '}
                    {LenderOrRetailer}
                    {' '}
                    will request a full credit report from one or more of the credit reporting agencies. This request will appear as a hard inquiry on your credit report and may affect your credit score. You further acknowledge and understand that additional soft credit inquiry reports may be requested and obtained from one or more of the credit reporting agencies during the application process or throughout the term of your
                    {' '}
                    {ricWorkFlow ? 'retail installment contract' : 'loan'}
                    . These soft pull inquiries will be requested: (1) to confirm that you continue to meet the
                    {' '}
                    {ricWorkFlow ? "Retailer's" : "Lender's"}
                    {' '}
                    credit criteria; (2) to prevent potential fraudulent activities; (3) for internal modeling and analysis purposes; (4) in servicing or monitoring any product(s) and/or service(s) you may have attained through LendingUSA and/or its
                    {' '}
                    {LenderOrRetailer}
                    ; (5) in collecting, enforcing or selling any
                    {' '}
                    {ricWorkFlow ? 'retail installment contract' : 'loan'}
                    {' '}
                    that you may receive from
                    {' '}
                    {LenderOrRetailer}
                    ; (6) in providing your credit data to you; (7) in offering you financial products and services; and/or (8) for any other lawful purpose.
                    <br />
                    <br />
                    You authorize your wireless carrier to disclose information about your account, such as subscriber status, payment method and device details, if available, to support identity verification, fraud avoidance and other uses in support of credit transactions. Information may also be shared with other service providers to further support identity verification and fraud prevention.
                    <br />
                    <br />
                    You further authorize and expressly consent to be contacted by
                    {' '}
                    {LenderOrRetailer}
                    , LendingUSA, their agents, representatives, assignees, affiliated third parties, or anyone calling on their behalf for any and all purposes (collectively &#34;Authorized Callers&#34;). This express consent applies to each such telephone number that you provide to any Authorized Caller, either now or in the future, even if the number is on a federal or state do-not-call list. You confirm you are the owner of the phone number(s), or that the owner authorized you to provide this phone number(s), or that you are the regular user of this phone number(s). You are providing express written consent authorizing any Authorized Caller to contact you at this number for any lawful purposes with a live operator, automatic telephone dialing system (auto-dialer) for both phone calls and text/SMS messages, prerecorded and artificial voice message, text/SMS message or other means.  Authorization may be revoked as described in our Terms of Use.  These telephone calls and text messages may incur message, data and access fees from your telephone provider.
                    <br />
                    <br />
                    Electronic Signature Agreement (&#34;Agreement&#34;). By clicking the &#34;TEXT MY PHONE TO PROCEED&#34; button, you are consenting to this Agreement and signing your Application electronically. You agree your electronic signature is the legal equivalent of your manual signature on this Application. By clicking &#34;TEXT MY PHONE TO PROCEED&#34;, you consent to be legally bound by LendingUSA&#39;s terms and conditions. You further agree that your use of a key-pad, mouse, touch pad or other device to select an item, button, icon or similar act/action online, through LendingUSA&#39;s Text-to-Apply mobile platform, merchant portal, or any other LendingUSA affiliated online platform constitutes your signature (hereafter referred to as &#39;E-Signature&#39;). You also agree that no third-party verification is necessary to validate your E-Signature, and that the lack of such third-party verification will not in any way affect the enforceability of your E-Signature, or of any resulting agreement between you and LendingUSA.
                    <br />
                    <br />
                    By clicking on &#34;TEXT MY PHONE TO PROCEED&#34; and continuing with this Application, you certify that: 1) you are the Applicant; 2) you are over the age of 18 years; 3) you are residing in the United States and; 4) all information that has been provided by you on this Application is true and accurate.
                  </div>
                  <div onClick={toggleDisclousureModal} className="btn btn-primary">OK</div>
                </div>
              </Modal>
            ) : null}

            {isElectronicModalVisible ? (
              <Modal>
                <div className="card-content error-modal security-error">
                  <p>Electronic Consent</p>
                  <div className="offer-page modal-content-wrapper">
                    <b>CONSENT FOR ELECTRONIC SIGNATURES, RECORDS, AND DISCLOSURES (&#34;E-Consent&#34;)</b>
                    <br />
                    Please read this information carefully and print a copy and/or retain this information electronically for future reference.
                    <br />
                    <br />
                    <u><b>Introduction.</b></u>
                    {' '}
                    You are using this &apos;Portal&apos; or &apos;Website&apos; to submit a request for consumer financial services
                    {' '}
                    {ricWorkFlow ? (
                      <>
                        through a retail installment sale (&apos;Consumer Financial Services&apos;) from
                        {' '}
                        {get(checkinData, 'data.data.businessName') ? `${get(checkinData, 'data.data.businessName')}, ` : null}
                        {get(checkinData, 'data.data.dba') ? ` dba ${get(checkinData, 'data.data.dba')} ` : null}
                        (&apos;Retailer&apos;) and/or
                      </>
                    ) : (
                      <>
                        from these
                        {' '}
                        <a href="https://lendingusa.com/lending-partners/" style={{ textDecoration: 'underline' }} target="_blank" rel="noopener noreferrer">lenders</a>
                        {' '}
                        (each a &#34;Bank&#34;),
                      </>
                    )}
                    {' '}
                    LendingUSA as operator of the Portal, and their assignees (hereinafter &#34;we,&#34; &#34;us,&#34; &#34;our,&#34; or
                    {' '}
                    {bankOrRetailer}
                    ), among other services. To provide these services, we need your consent to using and accepting electronic signatures, records, and disclosures (&#34;E-Consent&#34;). This E-Consent notifies you of your rights when receiving disclosures, notices, and information from the
                    {' '}
                    {bankOrRetailer}
                    {' '}
                    or LendingUSA. By clicking links or buttons assenting to our terms (&#34;Links&#34;), you agree that you received this E-Consent and that you consent to using electronic signatures, records, and disclosures. Additionally, by clicking Links, you consent to conduct transactions by using electronic disclosures, electronic records, and contract documents (&#34;Disclosures&#34;).
                    <br />
                    <br />
                    <u>Option for Paper or Non-Electronic Records.</u>
                    {' '}
                    You may request any Disclosures in paper copy by logging in and printing a paper copy. You may also mail your written request to LendingUSA, at the following address: 15303 Ventura Blvd. Suite 850, Sherman Oaks, CA 91403. We will provide paper copies at no charge. The
                    {' '}
                    {bankOrRetailer}
                    {' '}
                    or its assignee will retain all Disclosures as applicable law requires.
                    <br />
                    <br />
                    <u><b>Scope of Consent.</b></u>
                    {' '}
                    This E-Consent applies to all interactions online concerning you and
                    {' '}
                    {bankOrRetailer}
                    {' '}
                    and/or LendingUSA, and includes those interactions engaged in on any computer, electronic device, mobile device, including phones, smart-phones, fax machines, and tablets. Under this E-Consent,
                    {' '}
                    {bankOrRetailer}
                    {' '}
                    and/or LendingUSA will process your information and interact during all online interactions with you electronically. The Disclosures you will receive electronically include federal disclosures, such as the Truth-in-Lending disclosures, Privacy Notices, and notices of our credit decisions,
                    {' '}
                    {ricWorkFlow && 'and/or other financing decisions,'}
                    {' '}
                    as well as state-specific notices. We will also send you notices electronically related to our interactions and transactions. This E-Consent informs you of your rights when receiving these Disclosures electronically.
                    <br />
                    <br />
                    <u><b>Consenting to Do Business Electronically.</b></u>
                    {' '}
                    Before you decide to do business electronically with
                    {' '}
                    {bankOrRetailer}
                    {' '}
                    and/or LendingUSA, you should consider whether you have the required hardware and software capabilities described below.
                    <br />
                    <br />
                    <u><b>Hardware and Software Requirements.</b></u>
                    {' '}
                    To access and retain the Disclosures electronically, you will need to use a computer or device capable of accessing the Internet and an Internet Browser software program that supports at least 256-bit encryption, such as Microsoft® Internet Explorer 11+, Safari 7+ and the evergreen Chrome, Firefox or Edge. To read some documents, you may need a PDF file reader like Adobe® Acrobat Reader, Xpdf® or Foxit®. If these requirements change while you are maintaining an active relationship with
                    {' '}
                    {bankOrRetailer}
                    , and the change creates a material risk that you may not be able to receive Disclosures electronically,
                    {' '}
                    {bankOrRetailer}
                    {' '}
                    will notify you of these changes. You will need a printer or a long-term storage device, such as your computer&apos;s disk drive, to retain a copy of the Disclosures for future reference. You may send us your written questions regarding the hardware and software requirements to:
                    <br />
                    <br />
                    <b>Email</b>
                    <br />
                    CustomerCare@LendingUSA.com
                    <br />
                    <br />
                    <b>Call</b>
                    <br />
                    Our regular business hours are 9:00am to 5:00pm PST
                    <br />
                    800-994-6177
                    <br />
                    <br />
                    <b>Address for Regular Mail</b>
                    <br />
                    15303 Ventura Blvd., Suite 850
                    <br />
                    Sherman Oaks, CA 91403
                    <br />
                    <br />
                    <u><b>Withdrawing Consent.</b></u>
                    {' '}
                    You are free to withdraw this E-Consent at any time and at no charge. However, if you withdraw this E-Consent before receiving Consumer Financial Services, this will prevent you from obtaining Consumer Financial Services from us. If at any time you wish to withdraw this E-Consent, you can send us your written request by
                    {' '}
                    {ricWorkFlow ? 'mail' : 'e-mail'}
                    {' '}
                    to
                    {' '}
                    {ricWorkFlow && 'LendingUSA at '}
                    CustomerCare@LendingUSA.com with the details of such request. If you decide to withdraw this E-Consent, the withdrawal will not affect the legal effectiveness, validity, and enforceability of prior electronic Disclosures.
                    <br />
                    <br />
                    <u><b>Change to Your Contact Information.</b></u>
                    {' '}
                    You agree to keep us informed of any change in your electronic address or mailing address. You may update such information by calling us or emailing us to provide the updated information. You may also send us your written update by mail to our address above.
                    <br />
                    <br />
                    <u><b>YOUR ABILITY TO ACCESS DISCLOSURES.</b></u>
                    {' '}
                    BY CLICKING LINKS, YOU ASSENT TO OUR TERMS. YOU ACKNOWLEDGE AND REPRESENT THAT YOU CAN ACCESS THE DISCLOSURES IN THE DESIGNATED FORMATS DESCRIBED ABOVE. Once you give your consent, you can log into the website to access these documents.
                    <br />
                    <br />
                    <u><b>CONSENT.</b></u>
                    {' '}
                    BY CLICKING LINKS, YOU ASSENT TO OUR TERMS. YOU ACKNOWLEDGE YOU HAVE READ THIS INFORMATION ABOUT ELECTRONIC SIGNATURES, RECORDS, DISCLOSURES, AND DOING BUSINESS ELECTRONICALLY. YOU CONSENT TO USING ELECTRONIC SIGNATURES, HAVING ALL DISCLOSURES PROVIDED OR MADE AVAILABLE TO YOU IN ELECTRONIC FORM, AND TO DOING BUSINESS WITH US ELECTRONICALLY. YOU ACKNOWLEDGE THAT YOU MAY REQUEST A PAPER COPY OF THE ELECTRONIC RECORDS AND DISCLOSURES, WHICH WE WILL PROVIDE TO YOU AT NO CHARGE. IF YOU REFRAIN FROM PROCEEDING THEN YOU NEITHER WISH TO USE ELECTRONIC SIGNATURES NOR CONDUCT THIS TRANSACTION ELECTRONICALLY. YOU ALSO ACKNOWLEDGE THAT YOUR CONSENT TO ELECTRONIC DISCLOSURES IS REQUIRED TO RECEIVE CONSUMER FINANCIAL SERVICES FROM US OVER THE INTERNET.
                    <br />
                    <br />
                    Print and retain a hard copy or electronic copy.
                    <br />
                    <br />
                    <b>ELECTRONIC CONSENT AND ACKNOWLEDGMENT.</b>
                    {' '}
                    BY CLICKING LINKS, YOU CERTIFY THAT:
                    <br />
                    <ul>
                      <li>Your computer hardware and software meet the requirements needed to access and retain the Disclosures electronically.</li>
                      <li>You consent to receive the Disclosures electronically.</li>
                      <li>
                        You consent to sign your
                        {' '}
                        {ricWorkFlow ? 'retail installment contract' : 'Loan Agreement'}
                        {' '}
                        and related documents electronically.
                      </li>
                      <li>You understand and agree that you will be bound to the same terms and conditions if you sign the Disclosures electronically as if you signed paper Disclosures.</li>
                    </ul>
                  </div>
                  <div onClick={toggleElectronicModal} className="btn btn-primary">OK</div>
                </div>
              </Modal>
            ) : null}
          </div>
        </div>
      ) : !isReady ? (
        <div className="loading-wrapper">
          <PuffLoader size={100} color="#f44242" />
        </div>
      ) : <ErrorHandle msg={errorMessage} />}
    </Transition>
  );
};

OfferConfirmation.propTypes = {
  navigate: PropTypes.func.isRequired,
  validator: PropTypes.object.isRequired,
  checkinData: PropTypes.object.isRequired,
  offerCheckInAction: PropTypes.func.isRequired,
  newNextAction: PropTypes.func.isRequired,
};

ErrorHandle.propTypes = {
  msg: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

const mapDispatchToProps = {
  offerCheckInAction,
  newNextAction,
};

export default compose(
  Validator(schema),
  connect(mapStateToProps, mapDispatchToProps)
)(OfferConfirmation);
